export const calculateMaxBoxSize = (
  containerWidth: number,
  containerHeight: number,
  numBoxes: number,
  margin: number,
  isCollapsed?: boolean,
  aspectRatio: number = 0.75
): { boxWidth: number; boxHeight: number; cols: number } => {
  // Calculate the available width and height after accounting for margins
  const availableWidth = containerWidth - margin * 2;
  const availableHeight = containerHeight - margin * 2;

  // Initialize variables to store the best fit dimensions
  let bestBoxWidth = 0;
  let bestBoxHeight = 0;
  let bestCols = 1;

  if (isCollapsed) {
    // When collapsed, take the maximum available width
    bestBoxWidth = availableWidth;
    bestBoxHeight = bestBoxWidth * aspectRatio; // Enforce aspect ratio
    bestCols = 1;
  } else {
    // When not collapsed, calculate the best fit dimensions
    for (let cols = 1; cols <= numBoxes; cols++) {
      const rows = Math.ceil(numBoxes / cols);

      // Calculate the maximum possible box width and height for this arrangement
      const boxWidth = (availableWidth - (cols - 1) * margin) / cols;
      const boxHeight = (availableHeight - (rows - 1) * margin) / rows;

      // Enforce the aspect ratio: height = width * 0.75
      let adjustedBoxWidth = boxWidth;
      let adjustedBoxHeight = boxWidth * aspectRatio; // Force height to be width * 0.75

      // Check if the adjusted height exceeds the available height
      if (adjustedBoxHeight > boxHeight) {
        // If the forced height is too large, adjust the width instead
        adjustedBoxHeight = boxHeight;
        adjustedBoxWidth = boxHeight / aspectRatio; // Recalculate width based on height
      }

      // Check if the adjusted dimensions fit within the container
      const totalWidth = adjustedBoxWidth * cols + (cols - 1) * margin;
      const totalHeight = adjustedBoxHeight * rows + (rows - 1) * margin;

      if (totalWidth <= availableWidth && totalHeight <= availableHeight) {
        // Update the best dimensions if this arrangement is better
        if (adjustedBoxWidth > bestBoxWidth) {
          bestBoxWidth = adjustedBoxWidth;
          bestBoxHeight = adjustedBoxHeight;
          bestCols = cols;
        }
      }
    }
  }

  // Return the best fit dimensions
  return { boxWidth: bestBoxWidth, boxHeight: bestBoxHeight, cols: bestCols };
};

export const checkIfTimePassed = ({ createdAt, duration }: { createdAt: number; duration: string }) => {
  const durationInMillis = parseInt(duration, 10) * 60 * 1000;
  const currentTime = Date.now();
  const difference = currentTime - (createdAt + durationInMillis);
  return difference > 0;
};
